(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('SummaryController', SummaryController);

    SummaryController.$inject = ['$rootScope', 'Principal', '$translate', '$log', 'CartFactory', '$localStorage', '$window', 'SummaryService', '$state', 'CartLabelService', 'RegistrationService', 'ProjectService', '$sce'];

    function SummaryController($rootScope, Principal, $translate, $log, CartFactory, $localStorage, $window, SummaryService, $state, CartLabelService, RegistrationService, ProjectService, $sce) {

        // VARIABLES
        var vm = this;

        vm.summaryExhibitor = {};

        vm.cart = CartFactory.getCart();
        vm.totalPrice = CartFactory.totalPrice();
        vm.gtcDescription;
        vm.privacyDescription;
        vm.additionalPrivacyDescription;


        vm.lang = $translate.use();

        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.bookCart = bookCart;
        vm.back = back;
        vm.getLabelForItem = getLabelForItem;

        vm.preAuthorized=false;


        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            countryIdToCountryText();
        });
        getExhibitorAuthorities();

        loadSummaryData();

        return vm;

        // FUNCTIONS
        function pageLoaded() {
            if (true) {
                return true;
            }
            return false;
        }

        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                $log.debug('SummaryController | authorities', identity);
                if (identity.authorities.indexOf('PRE_AUTHORIZED') !== -1) {
                    vm.preAuthorized = true;
                }
            }, function() {
                $log.debug('SummaryController | ERROR IDENTITY', value);
            });
        }


        function loadSummaryData() {
            RegistrationService.getCurrentExhibitor().then(successExhibitor, error);
            SummaryService.loadSummaryLabels().then(successLabels, error);
            SummaryService.loadSummaryDocuments().then(successDocuments, error);
        }

        function successCountries(response) {
            $log.debug('SummaryController | Getting Countries...', response.data);
            vm.countries = response.data;
            countryIdToCountryText();
        }

        function successDocuments(response) {
            $log.debug('SummaryController | Getting Documents...', response.data);
            vm.documents = response.data;
        }


        function successExhibitor(response) {
            $log.debug("SummaryController | Exhibitor:", response);
            vm.summaryExhibitor = response.data;
            ProjectService.loadCountries($localStorage.project).then(successCountries, error);
        }

        function getLabelForItem(item) {
            return CartLabelService.getCartLabelForItem(item, vm.lang);
        }

        function countryIdToCountryText() {
            $log.debug('SummaryController | country ids to text');
            angular.forEach(vm.countries, function (value) {
                if (value.id == vm.summaryExhibitor.country) {
                    vm.country = value.translations[vm.lang];
                }
                if (value.id == vm.summaryExhibitor.companyRegisteredIn) {
                    vm.companyRegisteredIn = value.translations[vm.lang];
                }
            });
        }

        function successLabels(response) {
            vm.labels = [];
            $log.debug("SummaryController | Fetching text labels", response.data);
            angular.forEach(response.data, function(label, key) {
                if (key == 'gtcDescription' && label) {
                    vm.gtcDescription =  $sce.trustAsHtml(label[vm.lang]);
                }
                if (key == 'privacyDescription' && label) {
                    vm.privacyDescription =  $sce.trustAsHtml(label[vm.lang]);
                }
                if (key == 'additionalPrivacyDescription' && label) {
                    vm.additionalPrivacyDescription =  $sce.trustAsHtml(label[vm.lang]);
                }
            });

            vm.labels = response.data;
        }


        function error(response) {
            $log.debug('SummaryController | ERROR:', response);
        }

        function back() {
            $log.debug('SummaryController | back');
            $window.history.back();
        }

        function bookCart() {
            $log.debug('SummaryController | posting shopping cart', $localStorage.cart);
            CartFactory.book().then(successBooking, error);
        }

        function successBooking() {
            $log.debug('SummaryController | success posting areas. clearing cart now');
            CartFactory.clear();
            $localStorage.coExhibitors=[];
            $state.go('download');
        }
    }
})();
